// extracted by mini-css-extract-plugin
module.exports = {"catcher":"DevMenu_catcher__DbcrZ","menu":"DevMenu_menu__K4lGs","heading":"DevMenu_heading__EBoqv","item":"DevMenu_item__m3WTc","badge":"DevMenu_badge__Xc0WD"};